import { NavBar } from 'antd-mobile'
import React from 'react'

function NavbarH5(props) {
    return (
        <NavBar 
            onBack={props.onBack}
        >{props.title}</NavBar>
    )
}

export default NavbarH5